const getBaseQueryUrl = () => {
  const port = process.env.REACT_APP_API_PORT;
  const baseURL = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}/api/`;
  return baseURL;
};

export default getBaseQueryUrl;
